import { getUserProfileV2Async } from '@chr/online-shared-microsite-core';
import { initialize } from 'launchdarkly-js-client-sdk';
import { getConfiguration } from '@chr/common-web-ui-configuration';

export const launchdarkly = async () => {
  const appconfig = await getConfiguration<AppConfig>();
  try {
    const userProfile = await getUserProfileV2Async();

    if (!appconfig?.launchDarklyClientId) { throw new Error('launchDarklyClientId is missing'); }
    if (!userProfile?.userId) { throw new Error('userId is missing'); }

    const user  = {
      key: userProfile.userId.toString(),
      anonymous: false,
    };

    const options = { allAttributesPrivate: true };
    const ldClient = initialize(appconfig.launchDarklyClientId, user, options);

    await ldClient.waitForInitialization();

    return ldClient.allFlags();
  } catch (error) {
    console.error(error);
    return {};
  }
};
